import {getStorePlatform} from "@/store/api";

export default {
  name: 'AppFooter',
  props: {},
  data() {
    return {
      platform: null,
      platformExternalUrlHelp: null
    }
  },
  created: function () {
    this.platform = getStorePlatform()
    this.platformExternalUrlHelp = this.platform.urlHelp
  },
  mounted: function () {
    /* DOM accessible via this.$el */
  },
  beforeUnmount: function () { /* clean all non-Vue listeners/objects */
  },
  methods: {
    externalUrlHelp() {
      return this.platformExternalUrlHelp
    },
    externalUrlHelpExist() {
      return this.platformExternalUrlHelp != null
    }
  },
  computed: {
    currentYear() {
      return (new Date()).getFullYear()
    },
    // externalUrlHelp() {
    //   alert("this.externalUrlHelp:"+this.externalUrlHelp)
    //   if (this.externalUrlHelp) return this.externalUrlHelp;
    //   return false;
    // },
    disconnected() {
      if (this.$store.state.token) {
        return !(this.$store.state.user ? this.$store.state.user.email !== undefined : false)
      }
      return true
    },
  }
}
